import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'
import { PackagesStats } from './types'

const key = 'premiumFeaturesTrialsV2'

export const packagesStatsStorage = createKeyvalStorage<PackagesStats>(key)

export const packagesStatsView = createKeyvalView<PackagesStats>(key)
